import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/portfolio1.png";
import IMG2 from "../../assets/portfolio2.png";
import IMG3 from "../../assets/portfolio3.png";
import IMG4 from "../../assets/portfolio4.png";
import IMG5 from "../../assets/portfolio5.png";
// import IMG6 from "../../assets/portfolio6.jpg";

// DO NOT USE THE IMAGES IN PRODUCTION

const data = [
  {
    id: 1,
    image: IMG1,
    title: "Minesweeper Game using different state management",
    github: "https://github.com/SorinC6/Minesweeper-Game",
    demo: "https://minesweeperwoop.netlify.app/",
  },
  {
    id: 2,
    image: IMG2,
    title: "Web3 App - Send Ethereum",
    github: "https://github.com/SorinC6/Web3-SendETH-App",
    demo: "https://send-eth-web3.netlify.app/",
  },
  {
    id: 3,
    image: IMG3,
    title: "Share Image Application with ReactJs and Sanity - google login",
    github: "https://github.com/SorinC6/Share-Images-App",
    demo: "https://shareimgapp.netlify.app/",
  },
  {
    id: 4,
    image: IMG4,
    title: "ECommerce Shop using Sanity and Stripe integration",
    github: "https://github.com/SorinC6/ECommerce-App",
    demo: "https://ecommerce-kishsorin.vercel.app/",
  },
  {
    id: 5,
    image: IMG5,
    title: "Blog App using GraphQL, NextJS, Tailwind CSS",
    github: "https://github.com/SorinC6/Blog-Application",
    demo: "https://blog-application-34ox4qnbm-kishsorin.vercel.app/",
  },
  // {
  //   id: 6,
  //   image: IMG6,
  //   title: "Charts templates & infographics in Figma",
  //   github: "https://github.com",
  //   demo: "https://dribbble.com/shots/15887665-Orion-UI-kit-Charts-templates-infographics-in-Figma",
  // },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <div className="portofolio_content">
                <h3>{title}</h3>
                <div className="portfolio__item-cta">
                  <a
                    href={github}
                    className="btn"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>
                  <a
                    href={demo}
                    className="btn btn-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Live Demo
                  </a>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
